import { PromiseBuffer, SentryError } from '@sentry/utils';
import { NATIVE } from '../wrapper';
/** Native Transport class implementation */
var NativeTransport = /** @class */ (function () {
    function NativeTransport() {
        /** A simple buffer holding all requests. */
        this._buffer = new PromiseBuffer(30);
    }
    /**
     * @inheritDoc
     */
    NativeTransport.prototype.sendEvent = function (event) {
        if (!this._buffer.isReady()) {
            return Promise.reject(new SentryError('Not adding Promise due to buffer limit reached.'));
        }
        return this._buffer.add(function () { return NATIVE.sendEvent(event); });
    };
    /**
     * @inheritDoc
     */
    NativeTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    return NativeTransport;
}());
export { NativeTransport };
